// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 644) return "static/chunks/644.a1e865c2cc75c74bd6f0.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"773":"de95e18ac030e7145b7b","889":"9c779d42cb39390cb0ac"}[chunkId] + ".js";
};